/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { DataSourceControllerService } from './services/DataSourceControllerService';
import { MetadataControllerService } from './services/MetadataControllerService';
import { SnapshotControllerService } from './services/SnapshotControllerService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class DataStreamerApi {
    public readonly dataSourceController: DataSourceControllerService;
    public readonly metadataController: MetadataControllerService;
    public readonly snapshotController: SnapshotControllerService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '/data',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.dataSourceController = new DataSourceControllerService(this.request);
        this.metadataController = new MetadataControllerService(this.request);
        this.snapshotController = new SnapshotControllerService(this.request);
    }
}

